export default __webpack_public_path__ + "static/media/ropa-teatro-mujer.69014e49.png";